import { Quill } from 'react-quill-new';

// A heading's size on part of a line (a word, or a metric's chip), where a
// heading itself takes the whole line: an inline font-size, as the headings
// are sized, so it shows wherever the text does. Named for the style it
// writes, so it's read back from saved HTML as well as written.
export const TEXT_SIZE_FORMAT = 'font-size';

export const TEXT_SIZES = {
  h1: '2em',
  h2: '1.5em',
  h3: '1.17em',
};

const Parchment = Quill.import('parchment');

Quill.register(
  new Parchment.StyleAttributor(TEXT_SIZE_FORMAT, 'font-size', {
    scope: Parchment.Scope.INLINE,
    whitelist: Object.values(TEXT_SIZES),
  }),
  true,
);
